/** 发票寄送列表*/
export const API_GET_INVOICEEXPRESSLIST = {
  url: 'invoiceexpress/loadPage',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
/** 选择关联单据列表*/
export const API_GET_INVOICEEXPRESSLOADSTATEMENTPAGELIST = {
  url: 'invoiceexpress/loadStatementPage',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
/** 添加*/
export const API_GET_ADD_INSERTINVOICEEXPRESS = {
  url: 'invoiceexpress/insertInvoiceExpress',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
/** 操作快递*/
export const API_GET_OPERATEEXPRESS_ACTION = {
  url: 'invoiceexpress/operateExpress',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
/** 获取详情*/
export const API_GET_LOADINVOICE_ACTION_LOCK = {
  url: 'invoiceexpress/loadInvoice',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
/** 编辑保存*/
export const API_GET_EDITINVOICEEXPRESS = {
  url: 'invoiceexpress/editInvoiceExpress',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
